import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import useStepClickHandler from '../hooks/useStepClickHandler';

const StepMobile = ({
	isComplete,
	title,
	titleSideContent,
	showStepDivider = true,
	route
}) => {
	const labels = useLabels();
	const onClickHandler = useStepClickHandler(route, title);
	const dividerClass = showStepDivider ? 'border-bottom' : '';

	return (
		<>
			<button
				className={`d-flex flex-row align-items-center ddc-font-size-base ${dividerClass} py-3 btn-unstyled`}
				onClick={onClickHandler}
				type="button"
				aria-label={`${title}, 
					${isComplete ? labels.get('COMPLETE') : labels.get('INCOMPLETE')}`}
			>
				<span className="text-decoration-underline text-link text-link-muted">
					{title}
				</span>
				<div className="ml-auto d-flex align-items-center ddc-font-size-base">
					{titleSideContent && (
						<div className="d-inline-block">{titleSideContent}</div>
					)}
					<i
						className="ddc-icon-circle-check ddc-icon d-inline-block ml-3"
						style={{
							fontSize: '30px',
							color: isComplete
								? 'var(--color-info-500)'
								: 'var(--color-neutral-300)'
						}}
						aria-hidden="true"
					/>
				</div>
			</button>
		</>
	);
};

StepMobile.propTypes = {
	isComplete: PropTypes.bool,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	]).isRequired,
	titleSideContent: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	]),
	showStepDivider: PropTypes.bool,
	route: PropTypes.string
};

export default StepMobile;
